import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

export default function TreasurerDashboard() {
  return (
    <MDBox py={3}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={4}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="primary"
              icon="calendar_today"
              title="My Attendance"
              count="N/A"
              percentage={{
                color: "success",
                amount: "+5%",
                label: "than last month",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="success"
              icon="volunteer_activism"
              title="My Tithe"
              count="N/A"
              percentage={{
                color: "success",
                amount: "+12%",
                label: "this year",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="info"
              icon="groups"
              title="My Groups"
              count="N/A"
              percentage={{
                color: "info",
                amount: "",
                label: "active participation",
              }}
            />
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}
